import { useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'

const NewFolderDocumentPage = () => {
  const { navigation } = useNavigation()
  const { employeeId, folder, initialFolder, isLoading } = useOutletContext<{
    employeeId: string
    folder: Folder
    initialFolder: Folder
    isLoading?: boolean
  }>()

  if (isLoading || !folder || !initialFolder) {
    return (
      <Box width="full" alignItems="center" paddingY="s32">
        <Spinner />
      </Box>
    )
  }

  const backRoute = navigation.employees.id.documents.folderId.fullPath({
    id: employeeId,
    folderId: folder?.id,
  })

  return <NewDocument employeeId={employeeId} folder={initialFolder} backRoute={backRoute} />
}

export default NewFolderDocumentPage
